import { LABELS } from '@/constants/common/message.constants'
import { type Unpacked } from '@/utils/type-utils'

import { type TruckSpecificationEntity } from '../..'

/**
 * 荷台仕様種別
 */
export type CargoAreaSpecificationType = Unpacked<
  Exclude<TruckSpecificationEntity['cargoAreaSpecificationTypes'], null>
>

export const CARGO_AREA_SPECIFICATION_TYPE = {
  /** ジョルダー (2本) */
  JOLODA_2: 'JOLODA_2',
  /** ジョルダー (4本) */
  JOLODA_4: 'JOLODA_4',
  /** スタンション (サイド) */
  STANCHION_SIDE: 'STANCHION_SIDE',
  /** スタンション (中央部) */
  STANCHION_CENTER: 'STANCHION_CENTER',
  /** 床フック */
  FLOOR_HOOK: 'FLOOR_HOOK',
  /** 二層式 */
  TWO_TIER: 'TWO_TIER',
  /** 三層式 */
  THREE_TIER: 'THREE_TIER'
} as const satisfies Record<
  CargoAreaSpecificationType,
  CargoAreaSpecificationType
>

export const CARGO_AREA_SPECIFICATION_TYPE_LABEL = {
  [CARGO_AREA_SPECIFICATION_TYPE.JOLODA_2]: LABELS.JOLODA_2,
  [CARGO_AREA_SPECIFICATION_TYPE.JOLODA_4]: LABELS.JOLODA_4,
  [CARGO_AREA_SPECIFICATION_TYPE.STANCHION_SIDE]: LABELS.STANCHION_SIDE,
  [CARGO_AREA_SPECIFICATION_TYPE.STANCHION_CENTER]: LABELS.STANCHION_CENTER,
  [CARGO_AREA_SPECIFICATION_TYPE.FLOOR_HOOK]: LABELS.FLOOR_HOOK,
  [CARGO_AREA_SPECIFICATION_TYPE.TWO_TIER]: LABELS.TWO_TIER,
  [CARGO_AREA_SPECIFICATION_TYPE.THREE_TIER]: LABELS.THREE_TIER
} as const satisfies Record<CargoAreaSpecificationType, string>
